<template>
  <FilterTableViewer :search-on-column="searchOnColumn" :data-handler="GetData" :raw-filter-config="rawFilterConfig"
    :actions="actions" :ignored-keys="ignoredKeys" />
</template>

<script setup>
import { getJobsMapped, getNewestJobsMapped } from '@/Services/Ressources/API/JobService';

import FilterTableViewer from '@/components/Automation/FilterTableViewer.vue';

import rawFilterConfig from '@/config/Filters/filterConfigJobs.json';
import { actions } from '@/config/Actions/jobsActionsConfig';

const searchOnColumn = 'Process'

const ignoredKeys = new Set([
  'VersionId',
  'Nummer',
  'Jobkey',
  'organizationUnitId',
  'InputValues',
  'HasRecording',
  'Raw massage'
]);

async function GetData(date) {
  const validDate = date || '24hours'; // matches "24 hours".replace(/\s/g, "") from filter

  var rangeJobsData = await getJobsMapped(validDate);
  //var top10JobsData = await Top10NewJobs()
  var final = [/*...top10JobsData, */ ...rangeJobsData];
  return final;
}
</script>